import { jsx as _jsx } from "react/jsx-runtime";
var Reply = function Reply(_ref) {
  var className = _ref.className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#181B32' : _ref$color,
    ignoreColor = _ref.ignoreColor;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16 10H7.081L9.781 6.62501C10.126 6.19301 10.056 5.56401 9.625 5.21901C9.194 4.87501 8.564 4.94301 8.219 5.37501L4.219 10.375C3.927 10.741 3.927 11.259 4.219 11.625L8.219 16.625C8.417 16.872 8.707 17 9 17C9.22 17 9.44 16.928 9.625 16.781C10.056 16.436 10.126 15.807 9.781 15.375L7.081 12H16C16.551 12 17 12.449 17 13V18C17 18.552 17.448 19 18 19C18.552 19 19 18.552 19 18V13C19 11.346 17.654 10 16 10Z",
      fill: !ignoreColor ? color : undefined
    })
  });
};
export default Reply;